var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPdfBule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 1.33301L6.66663 1.33301C5.93329 1.33301 5.33329 1.93301 5.33329 2.66634V10.6663C5.33329 11.3997 5.93329 11.9997 6.66663 11.9997H14.6666C15.4 11.9997 16 11.3997 16 10.6663V2.66634C16 1.93301 15.4 1.33301 14.6666 1.33301ZM8.99996 6.33301C8.99996 6.88634 8.55329 7.33301 7.99996 7.33301H7.33329L7.33329 8.66634H6.33329V4.66634H7.99996C8.55329 4.66634 8.99996 5.11301 8.99996 5.66634V6.33301ZM12.3333 7.66634C12.3333 8.21967 11.8866 8.66634 11.3333 8.66634H9.66663V4.66634H11.3333C11.8866 4.66634 12.3333 5.11301 12.3333 5.66634V7.66634ZM15 5.66634H14V6.33301H15V7.33301H14V8.66634H13V4.66634L15 4.66634V5.66634ZM7.33329 6.33301H7.99996V5.66634H7.33329V6.33301ZM3.99996 3.99967H2.66663L2.66663 13.333C2.66663 14.0663 3.26663 14.6663 3.99996 14.6663H13.3333V13.333H3.99996L3.99996 3.99967ZM10.6666 7.66634H11.3333V5.66634H10.6666V7.66634Z",
    fill: "#01698B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdfBule);
export default __webpack_public_path__ + "static/media/IconPDFBule.a1d8270e41436ce553d9b05c96ebec8b.svg";
export { ForwardRef as ReactComponent };